const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IkFETUlOX1NUQVRJQ19UT0tFTiIsInJvbGUiOiJBRE1JTiIsImlhdCI6MTc2Mjc2MDA5OX0.eb12wid_2TMw9c0jyGxJ98M7lV-pZvuL8jxbg_HkN0o';

(async () => {


})();

/* -------------------- BRAND FORM SUBMISSION -------------------- */
/* document.addEventListener('DOMContentLoaded', function () {  
  const form = document.querySelector('#brandform');
  if (form) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const responseMsg = document.querySelector('.responseMessage');
      if (responseMsg) responseMsg.innerHTML = '';

      const requiredFields = ['name', 'email', 'postcode', 'websiteUrl', 'logoUrl'];
      let isValid = true;

      requiredFields.forEach(id => {
        const field = document.getElementById(id);
        if (field) field.style.borderColor = '';
        if (field) {
          if (field.type === 'file' && field.files.length === 0) {
            field.style.borderColor = 'red';
            isValid = false;
          } else if (field.value.trim() === '') {
            field.style.borderColor = 'red';
            isValid = false;
          }
        }
      });

      if (!isValid) {
        if (responseMsg) responseMsg.innerHTML = `<p style="color:red;">Please fill in all required fields.</p>`;
        return;
      }

      const formData = new FormData(form);

      try {
        const response = await fetch('https://revstrust.myshopify.com/apps/rev-proxy/api/brand/add', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`, 
          },
          body: formData
        });

        const result = await response.json();

        if (!response.ok) {
          if (result?.statusCode === 400 && result?.message === 'Validation failed') {
            const errorMsg = result?.validation?.body?.message || 'Validation failed. Please check your input.';
            if (responseMsg) {
              responseMsg.innerHTML = `<p style="color:red;">${errorMsg}</p>`;
            }
            return;
          } else {
            const errorMsg = result?.desc || result?.message || 'There was an error adding the brand. Please try again later.';
            if (responseMsg) {
              responseMsg.innerHTML = `<p style="color:red;">${errorMsg}</p>`;
            }
            return;
          }
        }

        if (responseMsg) responseMsg.innerHTML = `<p style="color:green;">${result.message || 'Brand added successfully!'}</p>`;
        form.reset();

      } catch (error) {
        console.error('Error:', error);
        if (responseMsg) responseMsg.innerHTML = `<p style="color:red;">Something went wrong. Please try again later.</p>`;
      }
    });
  } */

  /* -------------------- BRAND SEARCH FUNCTIONALITY -------------------- */
  /* const inputBox = document.getElementById('search_brand');
  const resultsDiv = document.getElementById('brandResults');
  const inputBoxParent = document.querySelector('.brandSearchInner');

  let debounceTimer;

  if (inputBox && resultsDiv) {
    inputBox.addEventListener('input', function (e) {
      const value = e.target.value.trim();
      clearTimeout(debounceTimer);

      if (value.length === 0) {
        resultsDiv.innerHTML = '';
        return;
      }

      resultsDiv.style.display = 'block';

      debounceTimer = setTimeout(() => {
        fetchBrandSuggestions(value);
      }, 400);
    });


    function isInsideInputOrResults(node) {
      if (!node) return false;
      return inputBox.contains(node) || resultsDiv.contains(node) || inputBoxParent.contains(node);
    }

    // 🟢 Show results on hover
    inputBoxParent.addEventListener('mouseleave', (e) => {
      const movedTo = e.relatedTarget;
      if (isInsideInputOrResults(movedTo)) return;

      setTimeout(() => {
        // check again: maybe user moved back quickly
        if (!resultsDiv.matches(':hover') && !inputBox.matches(':hover')) {
          resultsDiv.style.display = 'none';
        }
      }, 100);
    });

    inputBoxParent.addEventListener('mouseenter', (e) => {
      if (resultsDiv.innerHTML.trim() !== '') {
        resultsDiv.style.display = 'block';
      }
    });

    resultsDiv.addEventListener('mouseleave', (e) => {
      const movedTo = e.relatedTarget;
      if (isInsideInputOrResults(movedTo)) return;

      setTimeout(() => {
        if (!resultsDiv.matches(':hover') && !inputBox.matches(':hover')) {
          resultsDiv.style.display = 'none';
        }
      }, 100);
    });

    resultsDiv.addEventListener('mouseenter', () => {
      if (resultsDiv.innerHTML.trim() !== '') {
        resultsDiv.style.display = 'block';
      }
    });

    document.addEventListener('click', (e) => {
      if (!isInsideInputOrResults(e.target)) {
        resultsDiv.style.display = 'none';
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        resultsDiv.style.display = 'none';
      }
    });


    async function fetchBrandSuggestions(name) {
      try {
        resultsDiv.innerHTML = `<div class="search-box-sec"><p class="resultsLoading">Loading...</p></div>`;

        const response = await fetch(
          `https://revstrust.myshopify.com/apps/rev-proxy/api/brand/all?name=${encodeURIComponent(name)}`,
          {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,  // 👈 add Bearer token here
              'Accept': 'application/json'
            }
          }
        );

        const data = await response.json();

        const brands = data?.data?.data || [];

        if (brands.length === 0) {
          resultsDiv.innerHTML = `<div class="search-box-sec"><h4 class="noDataBrand">No brands found matching your search.</h4></div>`;
          return;
        }

        // Fetch reviews for all brands in parallel
        const reviewPromises = brands.map(brand =>
          fetch(
              `https://revstrust.myshopify.com/apps/rev-proxy/api/review/all?brandId=${brand._id}&status=ACTIVE`,
              {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`, // 👈 Include Bearer token
                  'Accept': 'application/json'
                }
              }
            )
            .then(res => {
              if (!res.ok) throw new Error(`Review API failed: ${res.status}`);
              return res.json();
            })
            .then(reviewData => {
              const reviews = reviewData?.data?.data || [];
              const pagination = reviewData?.data?.pagination || [];
              let overallRating = 0;
              let totalReviews = pagination.total;
              let ratingClass = 'green';

              if (totalReviews > 0) {

                overallRating = brand.averageRating;

                if (overallRating < 1.5) {
                  ratingClass = 'red';
                } else if (overallRating < 2.5) {
                  ratingClass = 'orange';
                } else if (overallRating < 4) {
                  ratingClass = 'yellow';
                } else if (overallRating < 4.5) {
                  ratingClass = 'light-green';
                } else {
                  ratingClass = 'green';
                }
              }
              return { brand, overallRating, totalReviews, ratingClass };
            })
            .catch(error => {
              console.error('Review fetch failed:', error);
              return { brand, overallRating: 0, totalReviews: 0, ratingClass: 'green' };
            })
        );

        const brandData = await Promise.all(reviewPromises);

        // Build final HTML
        const html = `
          <div class="search-box-sec">
            <div class="nike-sec">
              <div class="top-nike-side">
                <h5>Brands</h5>
                ${brandData.map(({ brand, overallRating, totalReviews, ratingClass }) => {
                  const encodedName = btoa(brand.name || '');
                  const encodedID = btoa(brand._id);
                  return `
                    <div class="review-side-item">
                      <a class="brandUrl" href="/pages/review?name=${encodedName}&id=${encodedID}">
                        <div class="review-side" data-brand-id="${brand._id}">
                          <div class="left-review">
                            ${
                              brand.logoUrl
                                ? `<div class="img-review"><img src="${brand.logoUrl}" alt="${brand.name || 'Brand Logo'}"></div>`
                                : `<div class="img-review"><img src="https://cdn.shopify.com/s/files/1/0973/5015/6618/files/dummylogo-1.png?v=1761740004" alt="${brand.name}"></div>`
                            }
                            <div class="content-review">
                              <h6>${brand.name}</h6>
                              <p class="recomInfo">
                                ${brand.websiteUrl ? `<span>${brand.websiteUrl}</span>` : ''}
                                ${totalReviews ? `<span class="recomDot"> • </span> <span>${totalReviews} reviews</span>` : ''}
                              </p>
                            </div>
                          </div>

                          <div class="right-review ${ratingClass}">
                            <svg aria-hidden="true" viewBox="0 0 16 16" fill="inherit"
                              class="CDS_Icon_icon__c30ce7 CDS_Icon_default__c30ce7"
                              xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" role="img">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M9.88 6.225H16l-4.929 3.504-3.047 2.149-4.953 3.504L4.952 9.73
                                0 6.225h6.119L8 .572l1.881 5.653Zm1.596 4.812L8
                                11.9l4.929 3.527-1.453-4.392Z">
                              </path>
                            </svg>
                            <span>${overallRating ? overallRating.toFixed(1) : '5.0'}</span>
                          </div>
                        </div>
                      </a>
                    </div>`; 
                  }).join('')}
              </div>
            </div>
          </div>
        `;

        resultsDiv.innerHTML = html;

      } catch (error) {
        console.error('Error fetching brand data:', error);
        resultsDiv.innerHTML = `<div class="search-box-sec"><p style="color:red;">Error fetching data. Please try again.</p></div>`;
      }
    }

  } 

}); */



/* document.addEventListener('DOMContentLoaded', async function () {

  // === HELPER FUNCTIONS ===
  function getStarsHTML(rating) {
    let starsHTML = '';
    const fullStars = Math.floor(rating);
    const partial = rating - fullStars;

    for (let i = 1; i <= 5; i++) {
      let fillPercent = 0;
      if (i <= fullStars) {
        fillPercent = 100;
      } else if (i === fullStars + 1 && partial > 0) {
        fillPercent = Math.round(partial * 100);
      }

      starsHTML += getStarSVG(fillPercent, 16, 15);
    }

    return `<div class="rating-stars">${starsHTML}</div>`;
  }

  function getBigStarsHTML(rating) {
    let starsHTML = '';
    const fullStars = Math.floor(rating);
    const partial = rating - fullStars;

    for (let i = 1; i <= 5; i++) {
      let fillPercent = 0;
      if (i <= fullStars) {
        fillPercent = 100;
      } else if (i === fullStars + 1 && partial > 0) {
        fillPercent = Math.round(partial * 100);
      }

      starsHTML += getStarSVG(fillPercent, 26, 25, true);
    }

    return `<div class="rating-stars big">${starsHTML}</div>`;
  }

  // === REUSABLE SVG FUNCTION ===

  function getStarSVG(fillPercent, width, height, isBig = false) {
    const gradientId = `grad-${Math.random().toString(36).substr(2, 9)}`;
    const starPath = isBig
      ? `M12.6432 0L15.6279 9.18585H25.2865L17.4725 14.863L20.4572 24.0489L12.6432 18.3717L4.8293 24.0489L7.81396 14.863L1.43051e-05 9.18585H9.65858L12.6432 0Z`
      : `M7.6084 0L9.40451 5.52786H15.2168L10.5146 8.94427L12.3107 14.4721L7.6084 11.0557L2.90612 14.4721L4.70223 8.94427L-5.38826e-05 5.52786H5.81229L7.6084 0Z`;

    return `
      <span class="star${isBig ? ' bigStar' : ''}">
        <svg width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="${gradientId}">
              <stop offset="0%" stop-color="#f58723"/>
              <stop offset="${fillPercent}%" stop-color="#f58723"/>
              <stop offset="${fillPercent}%" stop-color="#d9d9d9"/>
              <stop offset="100%" stop-color="#d9d9d9"/>
            </linearGradient>
          </defs>
          <path d="${starPath}" fill="url(#${gradientId})"/>
        </svg>
      </span>
    `;
  }



  function generateDynamicRatingBlock(reviews, totalreviews) {
    if (!reviews || reviews.length === 0) return `<div class="rating-header"><div class="rating-sec"><h3>Ratings</h3></div><div class="noReviews"><p>No reviews yet.</p></div>`;

    const ratingCounts = {5:0,4:0,3:0,2:0,1:0};
    let totalRatingSum = 0, totalRatingCount = 0;

    reviews.forEach(review => {
      const ratings = [
        review.product_store_rating,
        review.seller_rating,
        review.product_quality_rating,
        review.product_price_rating,
        review.issue_handling_rating
      ].filter(r => typeof r === 'number' && r > 0);

      const reviewAverage = ratings.length ? ratings.reduce((sum,r)=>sum+r,0)/ratings.length : 0;
      if (reviewAverage > 0) {
        const rounded = Math.round(reviewAverage);
        if (rounded >=1 && rounded <=5) ratingCounts[rounded]++;
        totalRatingSum += reviewAverage;
        totalRatingCount++;
      }
    });

    const totalReviews = totalreviews;
    const overallRating = totalRatingCount ? totalRatingSum/totalRatingCount : 0;
    const roundedOverall = overallRating.toFixed(1);

    const labels = {5:'Excellent',4:'Very Good',3:'Average',2:'Poor',1:'Terrible'};
    let ratingBarsHTML = '';
    for (let i=5;i>=1;i--){
      const count = ratingCounts[i];
      const percent = totalReviews ? ((count/totalReviews)*100).toFixed(1) : 0;
      ratingBarsHTML += `
        <div class="bar">
          <span class="label">${labels[i]}</span>
          <div class="progress">
            <div class="fill" style="width:${percent}%"></div>
          </div>
          <span class="count">${count}</span>
        </div>`;
    }

    return `
      <div class="rating-header">
        <div class="rating-sec"><h3>Ratings</h3></div>
        <div class="rating-overview">
          <div class="Reviews-star">
            ${getStarsHTML(overallRating)}
            <p>${totalReviews} Reviews</p>
          </div>
          <p class="out-pera">${roundedOverall} out of 5 stars — Rated ${
              roundedOverall >= 4.5 ? 'Excellent' :
              roundedOverall >= 4 ? 'Very Good' :
              roundedOverall >= 3 ? 'Average' :
              roundedOverall >= 2 ? 'Poor' : 'Terrible'
            }</p>
        </div>
      </div>
      <div class="rating-bars">${ratingBarsHTML}<a class="add-review-btn">Add Review</a></div>
    `;
  }


  // === PAGINATION HANDLER ===
  function renderPagination(pagination) {
    const { totalPages, page } = pagination || {};
    if (!totalPages || totalPages <= 1) return '';

    let pagesHTML = '';
    for (let i = 1; i <= totalPages; i++) {
      pagesHTML += `<a href="#" class="page-num ${i === page ? 'active' : ''}" data-page="${i}">${i}</a>`;
    }

    return `
      <div class="pagination-sec">
        <div class="pagination-container">
          ${page === 1 ? `<span class="prev disabled" data-page="${page - 1}">Previous</span>` : ` <a href="#" class="prev" data-page="${page - 1}">Previous</a>`}
          <div class="page-numbers">${pagesHTML}</div>
          ${page === totalPages ? `<span class="next disabled" data-page="${page + 1}">Next</span>` : ` <a href="#" class="next" data-page="${page + 1}">Next</a>`}
        </div>
      </div>
    `;
  }

  // === FETCH AND RENDER DATA ===
  const pageUrl = window.location.href;
  let params = new URLSearchParams(window.location.search);
  let encodedName = ''; let encodedID = '';
  if(params){
    encodedName = pageUrl.includes('pages/write-a-review') ? params.get('brand') : params.get('name');
    encodedID = params.get('id');
  }

  try {
    let decodedName = ''; let decodedID = '';
    if(encodedName != '' && encodedName != 'undefined' && encodedName != null){
      decodedName = atob(encodedName);
    }

    if(encodedID != '' && encodedID != 'undefined' && encodedID != null){
      decodedID = atob(encodedID);
    }

    if (!decodedID || decodedID ==='undefined' || decodedID == null) throw 'Invalid brand name';

    // Fetch brand data
    const brandResponse = await fetch(
      `https://revstrust.myshopify.com/apps/rev-proxy/api/brand/${decodedID}`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,  // 👈 Include Bearer token
          'Accept': 'application/json'
        }
      }
    );

    if (!brandResponse.ok) {
      throw new Error(`Brand API failed: ${brandResponse.status}`);
    }

    const brandJson = await brandResponse.json();
    const brand = brandJson?.data || {}; // ✅ brand is a single object, not an array

    if (brand.length === 0) return;

    let brand_id = brand._id;

    const brandInput = document.getElementById('brandId');
    if (brandInput) {
      brandInput.value = brand_id;
    }

    console.log(brand);

    // Fetch reviews
    const reviewResponse = await fetch(
      `https://revstrust.myshopify.com/apps/rev-proxy/api/review/all?brandId=${brand_id}&status=ACTIVE`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,  // 👈 Include Bearer token
          'Accept': 'application/json'
        }
      }
    );

    if (!reviewResponse.ok) {
      throw new Error(`Review API failed: ${reviewResponse.status}`);
    }

    const reviewData = await reviewResponse.json();
    const reviews = reviewData?.data?.data || [];

    // Create a frequency map (email → count)
    const emailCounts = reviews.reduce((acc, review) => {
      const email = review.email?.toLowerCase() || 'unknown';
      acc[email] = (acc[email] || 0) + 1;
      return acc;
    }, {});


    const reviewResponsePagination = await fetch(
      `https://revstrust.myshopify.com/apps/rev-proxy/api/review/all?brandId=${brand_id}&limit=10&status=ACTIVE`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,  // 👈 Include Bearer token
          'Accept': 'application/json'
        }
      }
    );

    if (!reviewResponsePagination.ok) {
      throw new Error(`Review API failed: ${reviewResponsePagination.status}`);
    }

    const reviewData1 = await reviewResponsePagination.json();
    const reviews1 = reviewData1?.data?.data || [];
    const pagination = reviewData1?.data?.pagination || [];

    let totalReviews = reviews.length;
    let overallRating = 0;

    if (totalReviews > 0) {
      if(brand.ratingSummary){
        overallRating = brand.ratingSummary.averageRating;
      }
      
    }

    // Optional: round to 1 decimal place
    overallRating = overallRating.toFixed(1);

    // === WRITE-A-REVIEW PAGE ===
    if (pageUrl.includes('pages/write-a-review')) {
      if(!params.has('brand') && !encodedName){
        if (!Shopify.designMode){
          window.location.href = '/';
        }
      }
      const resultsDivLeft = document.querySelector('.lft_nike');
      const resultsDivRight = document.querySelector('.rgt_nike');
      const reviewSidebar = document.querySelector('.reviewSideBar');

      resultsDivLeft.innerHTML = `
        <div class="img_nke_img">
          <img src="${brand.logoUrl || 'https://cdn.shopify.com/s/files/1/0973/5015/6618/files/dummylogo-1.png?v=1761740004'}" alt="${brand.name}" />
        </div>
        <div class="hd_lfnik">
          <h4>${brand.name || 'Unnamed Brand'}</h4>
          ${brand.websiteUrl ? `<p class="brandWebUrl"><a href="${brand.websiteUrl}" target="_blank">${brand.websiteUrl}</a></p>` : ''}
        </div>
      `;


      resultsDivRight.innerHTML = `<ul>${(overallRating > 0) ? `<li><h6>${overallRating}</h6></li>${getStarsHTML(overallRating)}` : ''} ${totalReviews ? `<li><p class="review_para">${totalReviews} Reviews</p></li>`: `<li>No reviews yet.</li>`}</ul>`;
        
      reviewSidebar.innerHTML = `
        <div class="rgt_start_review">
          ${(reviews.length > 0) ? `<div class="hding_rgtrtar">
            <h3 class="blck">Recent Reviews of This Website</h3>
          </div>
          <div class="rgt_reviwboxotr">
            ${reviews.slice(0, 3).map(r => {
              const avgRating = brand.averageRating;

              return `
                <div class="inside_rgtriew">
                  <h6 class="blck">${r.reviewTitle || 'Nice!'}</h6>
                  <div class="reiw_starul">
                    <ul>
                      ${avgRating ? `<li>${getStarsHTML(avgRating)}<p>${avgRating} out of 5 stars</p></li>` : ''}
                    </ul>
                  </div>
                  <div class="cont_rew">
                    ${r.reviewBody || "No review text provided."}
                  </div>
                </div>
              `;
            }).join('')}

          </div>` : `<div class="hding_rgtrtar"><h3 class="blck">Recent Reviews of This Website</h3><div class="rgt_reviwboxotr"><p>No reviews yet.</p></div></div>`}
        </div>`;

    // === REVIEW PAGE ===
    } else if (pageUrl.includes('/pages/review')) {
      if(!params.has('name') && !encodedName){
        if (!Shopify.designMode){
          window.location.href = '/';
        }
      }
      const resultsDiv = document.querySelector('.nke_hd_contnt');
      const conDiv = document.querySelector('.cont_start');
      const sidebarContainer = document.querySelector('.brandReviewSidebarWrap');

      // Brand list
      resultsDiv.innerHTML = `
        <div class="img_nke_img">
          <img src="${brand.logoUrl || 'https://cdn.shopify.com/s/files/1/0973/5015/6618/files/dummylogo-1.png?v=1761740004'}" alt="${brand.name}" />
        </div>
        <div class="otr_rwet">
          <div class="nke_contntbox">
            <h4>${brand.name || 'Unnamed Brand'}</h4>
            ${brand.websiteUrl ? `<p class="brandWebUrl"><a href="${brand.websiteUrl}" target="_blank">${brand.websiteUrl}</a></p>` : ''}
          </div>
          <div class="reiwpge_hdbox">
            <ul>
              ${(overallRating > 0) ? `<li><h6>${overallRating}</h6></li>${getStarsHTML(overallRating)}` : ''}
              ${(totalReviews > 0) ? `<li><p class="review_para">${totalReviews} Reviews</p></li>` : ''}
            </ul>
          </div>
        </div>
      `;


      // Contact section
      conDiv.innerHTML = `
        <div class="contbtn">
          <a href="mailto:${brand.email || '#'}" class="cta contbtn-sec">Contact ${brand.name || 'Brand'}</a>
        </div>
        <div class="gt_start">
          <a href="#" class="cta_scnd contbtn-sec">Get Started</a>
        </div>
        <div class="net_wrk">
          <a href="${brand.websiteUrl || '#'}">
            <img src="https://cdn.shopify.com/s/files/1/0973/5015/6618/files/network_website.png?v=1761733601" alt="${brand.name || 'Brand'}" />
          </a>
          <a href="${brand.websiteUrl || '#'}">Visit Website</a>
        </div>
      `;


      // Reviews container
      const allReviewsContainer = document.querySelector('.brandAllReviews');
      allReviewsContainer.innerHTML = `
        <div class="leftrvw_custmor">
          <div class="hd_rgtcst"><h2 class="blck"><span>${pagination.total}</span> Reviews From Our Customers</h2></div>
          <div class="shre_thrgbox"><p>Share Your Thoughts</p><div class="throg_box"><button type="button" class="cta throg_box_btn leaveReview">Leave a Review</button></div></div>
          
          ${(reviews.length > 0) ? `<div class="sort-dropdown">
            <label for="sort">Sort By:</label>
            <select id="sort" name="sort">
              <option value="newest" selected="">Newest</option>
              <option value="oldest">Oldest</option>
              <option value="popular">Most Popular</option>
              <option value="rating">Highest Rated</option>
            </select>
          </div>`: ''}
          
          <div class="revire_otrbox">
            ${reviews1.map(r => {
              // const reviewCount = emailCounts[r.email?.toLowerCase() || 'unknown'] || 1;
              const reviewCount = r.totalReviewsByEmail;
              return `
                <div class="inside_revew">
                  <div class="otr_padrevw">
                    <div class="recw_insidehd">
                      <div class="ins_recw_insild">
                        <div class="hd_rgtbx"><span>${r.name.charAt(0)}</span></div>
                        <div class="rgt_hdcont duble-side-sec">
                          <div class="content-rgt-side">
                            <h6>${r.name || 'Anonymous'}</h6>
                            <ul><li>${reviewCount} review${reviewCount > 1 ? 's' : ''}</li></ul>
                          </div>
                          <div class="img-rgt-side">
                            <img src="https://cdn.shopify.com/s/files/1/0973/5015/6618/files/verified-img.png?v=1762433209" alt="">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="product_resp">
                      <ul>
                        ${r.product_store_rating > 0 ? `<li>${getStarsHTML(r.product_store_rating)}<p>Product and Store Experience</p></li>` : ''}
                        ${r.seller_rating > 0 ? `<li>${getStarsHTML(r.seller_rating)}<p>Responsive and Helpful</p></li>` : ''}
                        ${r.product_price_rating > 0 ? `<li>${getStarsHTML(r.product_price_rating)}<p>Value for Price</p></li>` : ''}
                      </ul>
                    </div>
                    <div class="star_finalyy">
                      ${getBigStarsHTML(r.product_store_rating || 0)}
                      <div class="starfinly_cont">
                        <p class="outr_starfl">"${r.reviewTitle}"</p>
                        <p class="star_finlycont">${r.reviewBody}</p>
                      </div>
                      <div class="oct_tmbtnotr">
                        <ul>
                          <li>${new Date(r.createdAt).toLocaleDateString('en-US', {year:'numeric', month:'long', day:'numeric'})}</li>
                          <li>Unprompted review</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>`;
            }).join('')}
          </div>

          <div class="pagination-wrapper">${renderPagination(pagination)}</div>
        </div>`;

      // Sidebar
      sidebarContainer.innerHTML = `
        <div class="rgtrvw_custmor">
          <div class="review-card top-card">
            <div class="rating-sec"><h3>Ratings & Reviews</h3></div>
            <div class="rating-score">
              <div class="rating-span">
                ${(overallRating > 0) ? `<h3>${overallRating}</h3>${getStarsHTML(overallRating)}`: '<p>No reviews yet.</p>'}
              </div>
              ${totalReviews ? `<p>Based On <a href="#">${totalReviews} Reviews</a></p>`: ''}
            </div>
          </div>
          <div class="logo-card"><img src="https://revstrust.myshopify.com/cdn/shop/files/Ravtrust-logo_large.png?v=1761305780" alt="RevTrust Logo"></div>
          <div class="review-card">${generateDynamicRatingBlock(reviews, totalReviews)}</div>
        </div>`;
    }

  } catch (error) {
    console.log('Error:', error);
    if(pageUrl.includes('pages/review') || pageUrl.includes('pages/write-a-review')){
      if(!params.has('brand') && !encodedName){
        if (!Shopify.designMode){
          window.location.href = '/';
        }
      }
    }
  }

  const sortSelect = document.querySelector('.brandAllReviews .sort-dropdown #sort');
  let brandID = atob(encodedID);
  if (sortSelect) {
    sortSelect.addEventListener('change', async function() {
      const option = this.value;
      let orderby = '';
      let sortby = '';
      const reviewsContainer = document.querySelector('.revire_otrbox');

      if (option) {
        if (option === 'newest') {
          sortby = 'createdAt';
          orderby = 'desc';
        } else if (option === 'oldest') {
          sortby = 'createdAt';
          orderby = 'asc';
        } else if (option === 'popular') {
          sortby = 'product_quality_rating';
          orderby = 'desc';
        } else if (option === 'rating') {
          sortby = 'product_store_rating';
          orderby = 'desc';
        }

        try {
          const reviewResponse = await fetch(
            `https://revstrust.myshopify.com/apps/rev-proxy/api/review/all?brandId=${brandID}&sortBy=${sortby}&order=${orderby}&limit=10&status=ACTIVE`,
            {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${token}`,  // 👈 Include Bearer token
                'Accept': 'application/json'
              }
            }
          );

          if (!reviewResponse.ok) {
            throw new Error(`Review API failed: ${reviewResponse.status}`);
          }

          const data = await reviewResponse.json();
          const reviews = data?.data?.data || [];
          const pagination = data?.data?.pagination || [];

          if (reviewsContainer) {

            if (reviews.length > 0) {
              reviewsContainer.innerHTML = `
                ${reviews.map(r => `
                  <div class="inside_revew">
                    <div class="otr_padrevw">
                      <div class="recw_insidehd">
                        <div class="ins_recw_insild">
                          <div class="hd_rgtbx"><span>${r.name ? r.name.charAt(0) : ''}</span></div>
                          <div class="rgt_hdcont duble-side-sec">
                            <div class="content-rgt-side">
                              <h6>${r.name || 'Anonymous'}</h6>
                              <ul>
                                <li>1 review</li>
                              </ul>
                            </div>
                            <div class="img-rgt-side">
                              <img src="https://cdn.shopify.com/s/files/1/0973/5015/6618/files/verified-img.png?v=1762433209" alt="">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="product_resp">
                        <ul>
                          ${r.product_store_rating > 0 ? `<li>${getStarsHTML(r.product_store_rating)}<p>Product and Store Experience</p></li>` : ''}
                          ${r.seller_rating > 0 ? `<li>${getStarsHTML(r.seller_rating)}<p>Responsive and Helpful</p></li>` : ''}
                          ${r.product_price_rating > 0 ? `<li>${getStarsHTML(r.product_price_rating)}<p>Value for Price</p></li>` : ''}
                        </ul>
                      </div>
                      <div class="star_finalyy">
                        ${getBigStarsHTML(r.product_store_rating || 0)}
                        <div class="starfinly_cont">
                          <p class="outr_starfl">"${r.reviewTitle || ''}"</p>
                          <p class="star_finlycont">${r.reviewBody || ''}</p>
                        </div>
                        <div class="oct_tmbtnotr">
                          <ul>
                            <li>${new Date(r.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</li>
                            <li>Unprompted review</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                `).join('')}
              `;
            } else {
              reviewsContainer.innerHTML = `<p class="no-reviews">No reviews found for this brand.</p>`;
            }
            setTimeout(function(){
              document.querySelectorAll('.shimmer-active').forEach(el => el.classList.remove('shimmer-active'));
            },1500);
          }

        } catch (error) {
          console.log('Error fetching sorted reviews:', error);
        }
      }
    });
  }

  // === REMOVE SHIMMER AFTER LOAD ===
  document.querySelectorAll('.shimmer-active').forEach(el => el.classList.remove('shimmer-active'));


  document.addEventListener('click', async function(e) {
    const pageLink = e.target.closest('.pagination-container a[data-page]');
    const container = e.target.closest('.leftrvw_custmor');
    if (container) {
      const selectors = [
        'span',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'li', 'p',
        '.fill',
      ];
      
      container.querySelectorAll(selectors.join(',')).forEach(el => {
        el.classList.add('shimmer-active');
      });
    }

    if (!pageLink || pageLink.classList.contains('disabled')) return;
    e.preventDefault();

    const selectedPage = parseInt(pageLink.dataset.page);
    if (isNaN(selectedPage) || selectedPage <= 0) return;

    try {
      const reviewResponse = await fetch(
        `https://revstrust.myshopify.com/apps/rev-proxy/api/review/all?brandId=${brandID}&page=${selectedPage}&limit=10&status=ACTIVE`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,  // 👈 Add Bearer token
            'Accept': 'application/json'
          }
        }
      );

      if (!reviewResponse.ok) {
        throw new Error(`Review API failed: ${reviewResponse.status}`);
      }

      const data = await reviewResponse.json();
      const reviews = data?.data?.data || [];
      const pagination = data?.data?.pagination || {};

      const reviewsContainer = document.querySelector('.revire_otrbox');
      const paginationContainer = document.querySelector('.pagination-wrapper');
      if (reviewsContainer) {
        reviewsContainer.innerHTML = `
        ${reviews.map(r => `<div class="inside_revew">
          <div class="otr_padrevw">
            <div class="recw_insidehd">
              <div class="ins_recw_insild">
                <div class="hd_rgtbx"><span>${r.name.charAt(0)}</span></div>
                <div class="rgt_hdcont duble-side-sec">
                  <div class="content-rgt-side">
                    <h6>${r.name || 'Anonymous'}</h6>
                    <ul>
                      <li>1 review</li>
                    </ul>
                  </div>
                  <div class="img-rgt-side">
                    <img src="https://cdn.shopify.com/s/files/1/0973/5015/6618/files/verified-img.png?v=1762433209" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div class="product_resp">
              <ul>
                ${r.product_store_rating>0?`<li>${getStarsHTML(r.product_store_rating)}<p>Product and Store Experience</p></li>`:''}
                ${r.seller_rating>0?`<li>${getStarsHTML(r.seller_rating)}<p>Responsive and Helpful</p></li>`:''}
                ${r.product_price_rating>0?`<li>${getStarsHTML(r.product_price_rating)}<p>Value for Price</p></li>`:''}
              </ul>
            </div>
            <div class="star_finalyy">
              ${getBigStarsHTML(r.product_store_rating || 0)}
              <div class="starfinly_cont">
                <p class="outr_starfl">"${r.reviewTitle}"</p>
                <p class="star_finlycont">${r.reviewBody}</p>
              </div>
              <div class="oct_tmbtnotr"><ul><li>${new Date(r.createdAt).toLocaleDateString('en-US', {year:'numeric', month:'long', day:'numeric'})}</li><li>Unprompted review</li></ul></div>
            </div>
          </div>
        </div>`).join('')} `;
      }

      if(paginationContainer){
        paginationContainer.innerHTML = renderPagination(pagination);
      }

      document.querySelectorAll('.shimmer-active').forEach(el => el.classList.remove('shimmer-active'));
      
      const targetSection = document.querySelector('.brandAllReviews');
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

    } catch (error) {
      console.error('Pagination fetch error:', error);
    }
  }); 


}); */



document.addEventListener('DOMContentLoaded', function () {
  
  const params = new URLSearchParams(window.location.search);
  const encodedName = params.get('name');
  const encodedID = params.get('id');

  // Use event delegation for all clicks
  document.addEventListener('click', function(e) {
    // Check for .leaveReview button click
    if (e.target.closest('.leaveReview')) {
      e.preventDefault();
      if (encodedName) {
        window.location.href = `/pages/write-a-review?brand=${encodedName}&id=${encodedID}`;
      }
    }

    // Check for dynamically added Add Review buttons
    if (e.target.closest('.rgtrvw_custmor .rating-bars .add-review-btn')) {
      e.preventDefault();
      if (encodedName) {
        window.location.href = `/pages/write-a-review?brand=${encodedName}&id=${encodedID}`;
      }
    }
  });


  document.querySelectorAll('.reviw_imgbox').forEach(container => {
    const stars = container.querySelectorAll('.star');
    const hiddenInput = container.querySelector('input[type="hidden"]');

    stars.forEach(star => {
      const value = parseInt(star.dataset.value);

      // Hover effect
      star.addEventListener('mouseover', () => {
        stars.forEach(s => {
          const sValue = parseInt(s.dataset.value);
          if (sValue <= value) {
            s.classList.add('hovered');
          } else {
            s.classList.remove('hovered');
          }
        });
      });

      star.addEventListener('mouseout', () => {
        const selectedValue = parseInt(hiddenInput.value) || 0;
        stars.forEach(s => {
          const sValue = parseInt(s.dataset.value);
          s.classList.toggle('active', sValue <= selectedValue);
          s.classList.remove('hovered');
        });
      });

      // Click to select or toggle
      star.addEventListener('click', () => {
        const currentValue = parseInt(hiddenInput.value) || 0;

        if (currentValue === value) {
          // If clicked star is already selected, deselect it and higher
          hiddenInput.value = value - 1; // decrease rating
        } else {
          hiddenInput.value = value;
        }

        // Update active classes
        const newValue = parseInt(hiddenInput.value);
        stars.forEach(s => {
          const sValue = parseInt(s.dataset.value);
          s.classList.toggle('active', sValue <= newValue);
        });
      });
    });
  });


})


/* document.addEventListener('DOMContentLoaded', function () {

  const params = new URLSearchParams(window.location.search);
  const encodedName = params.get('brand');
  const encodedID = params.get('id');

  const form = document.querySelector('#reviewForm');
  if (form) {

    // Select all checkboxes inside #reviewForm with class .custom-checkbox
    document.querySelectorAll('#reviewForm .custom-checkbox input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('click', function() {
        if (this.checked) {
          this.value = true;
        } else {
          this.value = false;
        }
      });
    });


    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const responseMsg = document.querySelector('.responseMessage');
      if (responseMsg) responseMsg.innerHTML = '';

      const requiredFields = ['reviewTitle', 'reviewBody', 'name', 'email', 'term_and_condition', 'privacy_policy' ];
      let isValid = true;

      requiredFields.forEach(id => {
        const field = document.getElementById(id);
        if (field) field.style.borderColor = '';
        if (field) {
          if (field.type === 'file' && field.files.length === 0) {
            field.style.borderColor = 'red';
            isValid = false;
          } else if (field.value.trim() === '') {
            field.style.borderColor = 'red';
            isValid = false;
          }
        }
      });

      if (!isValid) {
        if (responseMsg) responseMsg.innerHTML = `<p style="color:red;">Please fill in all required fields.</p>`;
        return;
      }

      const formData = new FormData(form);

      try {
        const response = await fetch('https://revstrust.myshopify.com/apps/rev-proxy/api/review/add', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,  // 👈 Add Bearer token
          },
          body: formData // No need to set Content-Type when using FormData
        });

        if (!response.ok) {
          throw new Error(`Review API failed: ${response.status}`);
        }

        const result = await response.json();

        if (!response.ok) {
          const errorMsg = result?.desc || 'There was an error adding the review. Please try again later.';
          if (responseMsg) responseMsg.innerHTML = `<p style="color:red;">${errorMsg}</p>`;
          return;
        }

        if (responseMsg) {
          responseMsg.innerHTML = `
            <p style="color:green;">
              ${result.message || 'Review added successfully!'}
              <a class="viewAllReview" href="/pages/review?name=${encodedName}&id=${encodedID}">.View Review</a>
            </p>
          `;
        }
        form.reset();

      } catch (error) {
        console.error('Error:', error);
        if (responseMsg) responseMsg.innerHTML = `<p style="color:red;">Something went wrong. Please try again later.</p>`;
      }
    });
  }
})  */